module.exports = "<p>\n  incrementdetails-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-form/incrementdetails-form.component.html
// module id = ./src/app/hrms/serviceregister/incrementdetails/incrementdetails-form/incrementdetails-form.component.html
// module chunks = main